import React from "react"

import { useProductPositionTableRoomRowViewModel } from "../hooks/useProductPositionTableRoomRowViewModel"
import { ProductPositionTableRoomRowView } from "./ProductPositionTableRoomRowView"
import { ProductPositionTableRoomRowModelResult } from "./hooks/useProductPositionTableRoomRowModel"

export function ProductPositionTableRoomRowComponent(
  props: ProductPositionTableRoomRowModelResult
) {
  return (
    <ProductPositionTableRoomRowView
      {...useProductPositionTableRoomRowViewModel(props)}
    />
  )
}

export const ProductPositionTableRoomRow = React.memo(
  ProductPositionTableRoomRowComponent
) as typeof ProductPositionTableRoomRowComponent
